import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { encode } from '@/utils'

let loading
const getThis = (_vm, name) => {
    let result
    for(let i=0; i<_vm.$children.length; i++){
        if(_vm.$children[i].$el.id == name){
            result = _vm.$children[i]
        }else{
            result = getThis(_vm.$children[i], name)
        }
    }
    return result
}

const setLoading = (config, type) => {
    let routeName = window.vm.$route.name
    let requestUrl = config.url
    let loadingName = (requestUrl.substring(requestUrl.lastIndexOf('\/') + 1, requestUrl.length)) + '_loading'
    let _this = getThis(window.vm, routeName)
    if(_this){
        _this[loadingName] = type
    }
}

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
    withCredentials: false, // 跨域请求时发送 cookies
    timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
		config.headers.oper && (config.headers.oper = encode(config.headers.oper))
        // Do something before request is sent
        setLoading(config, true)
        // console.log(config.closeLoading)
        loading = Loading.service({})
        if (store.getters.token) {
            // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
            config.headers['token'] = getToken()
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        loading.close()
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get information such as headers or status
     * Please return  response => response
    */
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
	
    response => {
        loading.close()
		if(response.data == null || response.data.length==0){
			return null
		}
		if(response.data.msg=='操作成功'&&(response.config.tip!=false)){
			Message({
			    message: '操作成功',
			    type: 'success',
			    duration: 3 * 1000
			})
		}
        const res = response.data
        if (res.code !=0 &&res.code && response.config.tip !== 0){
            Message({
                message: res.msg||'error',
                type: 'error',
                duration: 3 * 1000
            })
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            // if (res.code === 50008 || res.code === 50012 || res.code === 401) {
            //     // 请自行在引入 MessageBox
            //     // import { Message, MessageBox } from 'element-ui'
            //     MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
            //         confirmButtonText: '重新登录',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         store.dispatch('user/resetToken').then(() => {
            //             location.reload() // 为了重新实例化vue-router对象 避免bug
            //         })
            //     })
            // }
            return Promise.reject(res.message || 'error')
        } else {
            return res
        }
    },
    error => {
        loading.close()
        if(error.message.indexOf('timeout') >= 0){
            error.message = '请求超时，请重试'
        }else if(error.response.status == 401){
            error.message = '登录超时，请重新登录'
            store.dispatch('logout')
            setTimeout(() => {
                location.reload()
            }, 2000)
        }else if(error.response.data && error.response.data.msg){
            error.message = error.response.data.msg
        }
        setLoading(error.config, false)
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
